// Modes a return opened from the OMS can take, mirroring the API's ReturnRequestResolution enum.
export const ReturnResolutions = {
    BY_POST: 'return_by_post',
    IN_STORE: 'return_in_store',
};
